import React, { useState } from 'react';
import ConfirmActionModal from '../../components/ConfirmActionModal';
import BasePopover from '../../components/BasePopover';
import type { ActionModalProps } from '../../constants';
import useTrackEvent from '~/hooks/useTrackEvent';

const text = {
  title: 'Contacten toewijzen aan vestiging en gebruiker via werkgebied',
  confirm: 'Bevestigen',
  popoverDescription:
    'Contacten binnen een werkgebied worden automatisch toegewezen aan de bijbehorende vestiging en gebruiker.',
};

export type Props = {} & ActionModalProps;

const AssignToWorkingAreaOfficeUser: React.FCC<Props> = ({
  onCancel,
  onComplete,
  selectedContactAmount,
  ...rest
}) => {
  const [showModal, setShowModal] = useState(false);
  const hideModal = () => setShowModal(false);
  const trackEvent = useTrackEvent();

  return (
    <>
      {showModal ? (
        <ConfirmActionModal
          selectedContactAmount={selectedContactAmount}
          actionType="AssignToWorkingAreaOfficeUser"
          actionInput={{
            AssignToWorkingAreaOfficeUser: {
              noOperation: null,
            },
          }}
          onComplete={() => {
            /** ----- TRACKING: contacts_assigned_to_working_area ----- */
            trackEvent({
              eventName: 'contacts_assigned_to_working_area',
              parameters: {
                contacts_amount: selectedContactAmount,
              },
            });
            hideModal();
            onComplete();
          }}
          onCancel={hideModal}
          {...rest}
        />
      ) : (
        <BasePopover
          title={text.title}
          handleAction={confirm => {
            if (confirm) {
              setShowModal(true);
            } else {
              onCancel();
            }
          }}
          confirmText={text.confirm}
        >
          {text.popoverDescription}
        </BasePopover>
      )}
    </>
  );
};

export default AssignToWorkingAreaOfficeUser;
